import type { OrderInvoiceFields, OrderInvoiceFile } from '../interfaces'
import type { OrderInvoicePreviewState } from '../types'
import type { OrderInvoiceStore } from './interfaces'

import { cloneInvoiceFields } from '../../../lib/invoice-fields'

export const actions = {
  setLoading (this: OrderInvoiceStore, payload: OrderInvoiceStore['loading']): void {
    this.loading = payload
  },
  setPreviewLoading (this: OrderInvoiceStore, payload: OrderInvoiceStore['previewLoading']): void {
    this.previewLoading = payload
  },
  setFields (this: OrderInvoiceStore, payload: OrderInvoiceFields): void {
    this.saved = cloneInvoiceFields(payload)
    this.draft = cloneInvoiceFields(payload)
  },
  setDraftParentFullName (this: OrderInvoiceStore, payload: string | null): void {
    if (!this.draft) return

    this.draft.parent_full_name = payload
  },
  setDraftAddress (this: OrderInvoiceStore, payload: string | null): void {
    if (!this.draft) return

    this.draft.address = payload
  },
  setDraftItemDetails (this: OrderInvoiceStore, orderItemId: number, payload: string | null): void {
    const item = this.draft?.items.find(row => row.order_item_id === orderItemId)
    if (!item) return

    item.details = payload
  },
  clearDraft (this: OrderInvoiceStore): void {
    if (!this.draft) return

    this.draft = {
      parent_full_name: null,
      address: null,
      items: this.draft.items.map(item => ({ ...item, details: null })),
    }
  },
  setInvoices (this: OrderInvoiceStore, payload: OrderInvoiceStore['invoices']): void {
    this.invoices = payload
  },
  addInvoice (this: OrderInvoiceStore, payload: OrderInvoiceFile): void {
    this.invoices = [payload, ...this.invoices]
  },
  setSaved (this: OrderInvoiceStore, payload: OrderInvoiceFields): void {
    this.saved = cloneInvoiceFields(payload)
  },
  setPreview (this: OrderInvoiceStore, blob: Blob | null, state: OrderInvoicePreviewState): void {
    this.preview = blob ? markRaw(blob) : null
    this.previewState = state
  },
  reset (this: OrderInvoiceStore): void {
    this.loading = false
    this.previewLoading = false
    this.saved = null
    this.draft = null
    this.invoices = []
    this.preview = null
    this.previewState = 'automatic'
  },
}
